//#region Libraries
//#endregion
//#region Styles
import { Row } from "components/styles";
//#endregion
//#region Components
import CustomSelect from "components/CustomSelect/CustomSelect";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
//#endregion
//#region Utils
import { getOptionsToCustomSelect } from "components/CustomSelect/utils";
//#endregion

const PredefinedEnvironmentControls = ({
    environmentList,
    environment, changeEnvironment,
    error
}) => {
    const changeEnvironmentById = id => {
        const environmentFound = environmentList.find(currentEnvironment => currentEnvironment.id === id);
        changeEnvironment(environmentFound);
    }
    const {
        id, 
        address, 
        floor, 
        capacity
    } = environment;
    return (
        <Row justifyContent="flex-start">
            <CustomSelect
                label="Escoge un ambiente"
                value={id}
                onChange={changeEnvironmentById}
                optionsProps={getOptionsToCustomSelect(environmentList, { id: "id", text: "environmentCode" })}
                error={error}
                errorText="Es necesario seleccionar un ambiente"
                defaultOptionText="Selecciona un ambiente"
                disabled={environmentList.length === 0}/>
            <CustomTextInput
                label="Dirección"
                placeholder="Dirección"
                minWidth="350px"
                value={address}
                disabled/>
            <CustomTextInput
                label="Piso"
                placeholder="Piso"
                minWidth="150px"
                value={floor}
                disabled/>
            <CustomTextInput
                label="Capacidad"
                placeholder="Capacidad"
                minWidth="150px"
                value={capacity}
                disabled/>
        </Row>
    );
}

export default PredefinedEnvironmentControls;